import React, { Component } from 'react'
import { Row, Col, Input, Alert } from 'antd'

class PublicRecoverStart extends Component {

    render() {
        return (
            <div style={{marginTop: '24px'}}>
                <form method="post" onSubmit={(e) => {
                    e.preventDefault()
                    this.props.onSubmit(this.refs)
                }}>
                    <Row>
                        <Col xs={24} sm={6}></Col>
                        <Col xs={24} sm={14}><legend>Iniciar Recuperação da Palavra-passe</legend></Col>
                    </Row>

                    <div className="ant-row ant-form-item">
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                            <label htmlFor="title" className="ant-form-item-required" title="Endereço de E-mail">
                                Endereço de E-mail / Username
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                            <Input id="title"
                                defaultValue={this.props.email}
                                ref="email"
                            />
                        </div>
                    </div>

                    <Row>
                        <Col xs={24} sm={6}></Col>
                        <Col xs={24} sm={14}>
                            <Alert className={this.props.complete && this.props.error ? '' : 'hidden'}
                                message="Erro"
                                description={this.props.error}
                                type="error"
                                showIcon
                            />
                            <Alert className={this.props.complete && !this.props.error ? '' : 'hidden'}
                                message="Sucesso!"
                                description="Verifique a sua caixa de correio eletrónico e siga os passos."
                                type="success"
                                showIcon
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={24} sm={6}></Col>
                        <Col xs={24} sm={14}>
                            <div style={{borderTop: '2px solid gray', marginTop: '16px', paddingTop: '8px'}}>
                                <button type="submit" className="ant-btn ant-btn-primary" style={{float: 'right'}}>
                                    <span>Iniciar</span>
                                    <i className="anticon anticon-unlock"></i>
                                </button>
                            </div>
                        </Col>
                    </Row>

                </form>
            </div>
        )
    }
}

export default PublicRecoverStart;



// WEBPACK FOOTER //
// ./src/components/PublicRecoverStart.js